
import { ContainerMixin } from "vue-slicksort";
import { Component, Mixins } from "vue-property-decorator";

@Component
// @ts-expect-error: https://github.com/Jexordexan/vue-slicksort/issues/143
export default class SortableGroup extends Mixins(ContainerMixin) {}
